export default function BookingService(
    $http,
    API_SERVER,
    PrepareReqApiV3,
    Log
) {
    var service = {
        // currentBookings: [],
        combinedBookings: [], // JS ALTERATION - UNITED COHEREN BOOKINGS -> TSendt this to server RESERVE BOOKINGS FINAL
        // activity: null,
        // location: null,
        bookingHouseType: {},

        /**
         * API V3
         */

        /**
         * get booking
         * swagger : https://apiv3.projektbookbyen.dk/index.html#/Bookings/Bookings_GetBooking
         */

        get: function (id) {
            // Endpoint:
            const endpoint = `/bookings/${id}`;

            const params = `?expand=bookingperiods,payments`;

            const url = API_SERVER + endpoint + params;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.get(url).then(function (res) {
                return res.data;
            });
        },

        getByUid: function (uid) {
            // Endpoint:
            const endpoint = `/bookings/:get_by_uid`;

            const params = `?uid=${uid}&expand=bookingperiods`;

            const url = API_SERVER + endpoint + params;

            Log.endpoint(endpoint, url, "ApiV3");

            const headers = {
                endpointType: "noTokenRequired", // used by interceptor to skip access token
            };

            return $http.get(url, { headers: headers }).then(function (res) {
                return res.data;
            });
        },

        /**
         * Update booking (not in use)
         * swagger : https://apiv3.projektbookbyen.dk/index.html#/Bookings/Bookings_UpdateBooking
         */
        update: (id, updateBookingModel) => {
            // Endpoint:
            const endpoint = `/bookings/${id}`;

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.put(url, updateBookingModel).then(function (res) {
                return res.data;
            });
        },

        cancelBooking: function (id) {
            // Endpoint:
            const endpoint = `/bookings/${id}/cancel_booking`;

            const params = `?notify_email=true`;

            const url = API_SERVER + endpoint + params;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.post(url).then(function (res) {
                return res.data;
            });
        },

        /**
         * complete Booking
         */
        completeBooking: function (id) {
            // Endpoint:
            const endpoint = `/bookings/${id}/complete_booking`;

            const params = `?notify_email=true`;

            const url = API_SERVER + endpoint + params;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.post(url).then(function (res) {
                return res.data;
            });
        },

        createBookingId: (userId) => {
            // Endpoint:
            const endpoint = "/bookings";

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            const reqObj = {
                userId: userId,
                paymentType: 3, // must be 3
                note: null,
                externalNote: null,
                pspElement: null,
            };

            return $http.post(url, reqObj).then(function (res) {
                return res.data.id;
            });
        },

        /**
         * CRUD bookings/id/BookingPeriods
         */

        getBookingPeriods: function (id) {
            // Endpoint:
            const endpoint = `/bookings/${id}/booking_periods`;

            const params = `?expand=resource,activity`;

            const url = API_SERVER + endpoint + params;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.get(url).then(function (res) {
                return res.data;
            });
        },

        createBookingPeriodLegacy: (
            period,
            bookingId,
            activity,
            user,
            bookingTypeId
        ) => {
            /**
             * LEGACY to ApiV3
             * Since the periods is still in legacy mode, we need to prepare the request body to ApiV3
             */

            if (bookingTypeId == null) bookingTypeId = 1; // Default booking

            const preparedPeriod = PrepareReqApiV3.preparePeriod(
                period.LaneID,
                user.displayName,
                period.Price,
                period.BookingStart,
                period.BookingEnd,
                activity.CategoryID,
                bookingTypeId
            );

            // Endpoint:
            const endpoint = `/bookings/${bookingId}/booking_periods`;

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.post(url, preparedPeriod).then(function (res) {
                return res;
            });
        },

        createBookingPeriod: (period, bookingId, activityId, user, isFixed) => {
            const bookingTypeId = isFixed == true || isFixed == "true" ? 11 : 1;
            const preparedPeriod = PrepareReqApiV3.preparePeriod(
                period.resourceId,
                user.displayName,
                period.price,
                period.start,
                period.end,
                activityId,
                bookingTypeId
            );

            // Endpoint:
            const endpoint = `/bookings/${bookingId}/booking_periods`;

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.post(url, preparedPeriod).then(function (res) {
                return res;
            });
        },

        updateBookingPeriod: (bp) => {
            // Endpoint:
            const endpoint = `/bookings/${bp.bookingId}/booking_periods/${bp.id}`;

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.put(url, bp).then(function (res) {
                return res;
            });
        },

        deleteBookingPeriod: (bp) => {
            // Endpoint:
            const endpoint = `/bookings/${bp.bookingId}/booking_periods/${bp.id}`;

            const url = API_SERVER + endpoint;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.delete(url).then(function (res) {
                return res;
            });
        },

        verify: (id) => {
            const endpoint = `/bookings/${id}/:verify`;

            const url = `${API_SERVER}${endpoint}`;

            Log.endpoint(endpoint, url, "ApiV3");

            return $http.get(url).then(function (res) {
                return res.data;
            });
        },
    };

    return service;
}
